import {Component, input} from '@angular/core';
import {SvgSpriteIcon} from '@selpia/shared/ui';
import {Sentiment} from '@selpia/shared/models';

@Component({
  selector: 'lib-direction-indicator',
  standalone: true,
  templateUrl: './direction-indicator.component.html',
  styleUrl: './direction-indicator.component.scss',
  host: {
    '[class.hidden]': '!value()',
  },
})
export class DirectionIndicatorComponent {
  readonly value = input<Sentiment>();
  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
